import {
  AGREEMENT_TYPES,
  APP_MINIMUM_BALANCE,
  SystemCode,
  MONEY_MARKET_EVENT_FEE,
  MONEY_MARKET_EVENT_GATE,
  MONEY_MARKET_EVENT_PERIOD_IN_EVENT,
  NON_FIDUCIARY_PLAN,
  DELIVERY_IN_KIND,
  DELIVERY_MAIL_CHECK_TO_SCHOOL,
  FundNoteQCD,
  DELIVERY_MAIL_CHECK_QCD,
} from 'src/settings/settings';
import { isAPP } from '../../advice/advice-utility';
import {
  checkFoundFeaturesByCode,
  DISABLE_ON_MATCH,
  missingRedemptionFeature,
  updateFundNote,
} from '../shared/shared-fund-notes-utility';
import { isRAS } from 'src/utils/advice/advice-utility';

export function updateQCDFundNotesForFund(
  deliveryMethod,
  fund,
  isCheckWithMultipleAddress
) {
  // const userDoesNotOwnFund =
  //   fund?.agreementParties?.filter((party) => {
  //     return party.roleCode === 'OWNR' && party.businessPartyID === BPID;
  //   }).length === 0;
  // If RAS+APP client selects In-Kind Transfer as their delivery option,
  // RAS accounts will be disabled and an "In-Kind Transfer Unavailable" note
  // will be added to the notes section.
  updateFundNote(
    fund,
    deliveryMethod === DELIVERY_IN_KIND,
    FundNoteQCD.NO_RAS_IN_KIND_TRANSFER,
    DISABLE_ON_MATCH
  );
  //is APP fund with less than 10K balance
  updateFundNote(
    fund,
    isAPP(fund.productType) &&
      fund.balanceAsOf > 0 &&
      fund.balanceAsOf <= APP_MINIMUM_BALANCE,
    FundNoteQCD.INELIGIBLE_BALANCE
  );

  //if the fund is not owned by the person logged in block the fund
  updateFundNote(
    fund,
    fund.agreementType === AGREEMENT_TYPES.TRADITIONAL_IRA_DECEASED_BENE ||
      fund.agreementType === AGREEMENT_TYPES.ROTH_IRA_DECEASED_BENE,
    FundNoteQCD.QCD_INHERITED_IRA,
    DISABLE_ON_MATCH
  );

  // If client has a fund that has a "Stop Transfer" service in effect (ServiceCode: 31)
  // "Stop Transfer" will be added to the notes section.
  updateFundNote(
    fund,
    checkFoundFeaturesByCode(fund, SystemCode.STOP_TRANSFER_ID),
    FundNoteQCD.STOP_TRANSFER,
    DISABLE_ON_MATCH
  );

  // If client has a fund that has a "Penalty Withholding Flag" service in effect (ServiceCode: 32)
  // "IRS Tax Withholding" will be added to the notes section.
  updateFundNote(
    fund,
    checkFoundFeaturesByCode(fund, SystemCode.PENALTY_WITHOLDING),
    FundNoteQCD.PENALTY_WITHHOLDING,
    DISABLE_ON_MATCH
  );

  // If client has a fund that has a "Automated Systems Stop Redemption" service in effect (ServiceCode: 46)
  // "Unavailable Online" will be added to the notes section.
  updateFundNote(
    fund,
    checkFoundFeaturesByCode(
      fund,
      SystemCode.AUTOMATED_SYSTEMS_STOP_REDEMPTION_ID
    ),
    FundNoteQCD.AUTOMATED_SYSTEMS_STOP_REDEMPTION,
    DISABLE_ON_MATCH
  );

  // If client has a fund that has a "Automated Systems Stop Redemption" service in effect (ServiceCode: 46)
  // "Unavailable Online" will be added to the notes section.
  updateFundNote(
    fund,
    checkFoundFeaturesByCode(
      fund,
      SystemCode.AUTOMATED_SYSTEMS_STOP_REDEMPTION_ID
    ),
    FundNoteQCD.AUTOMATED_SYSTEMS_STOP_REDEMPTION,
    DISABLE_ON_MATCH
  );

  // If client has a fund in which balanceAsOf and equityAsOf are not equal
  // "Uncollected shares" will be added to the notes section.
  updateFundNote(
    fund,
    fund.hasUncollectedShares,
    FundNoteQCD.UNCOLLECTED_SHARES
  );

  // If client has a fund in which balanceAsOf and equityAsOf are not equal and the balance is zero
  // "Uncollected shares" will be added to the notes section and the we will not allow them to trade
  updateFundNote(
    fund,
    fund.hasUncollectedShares && fund.equityAsOf === 0 && fund.balanceAsOf > 0,
    FundNoteQCD.ZERO_BALANCE_WITH_UNCOLLECTED_SHARES,
    DISABLE_ON_MATCH
  );

  // If client has a fund in which restrictedAddressChanges is true and have selected MailACheck delivery method
  // "Address change pending" will be added to the notes section and that particular fund is locked.
  updateFundNote(
    fund,
    isCheckWithMultipleAddress && fund.restrictedByAddressChange,
    FundNoteQCD.ADDRESS_CHANGE_PENDING,
    DISABLE_ON_MATCH
  );

  updateFundNote(
    fund,
    deliveryMethod === DELIVERY_MAIL_CHECK_QCD &&
      fund.restrictedByAddressChange,
    FundNoteQCD.ADDRESS_CHANGE_PENDING,
    DISABLE_ON_MATCH
  );

  // If client has selected any Delivery Method in step1
  // If the fund has a missing Required feature with service code 20 or has all three missing Required features then that fund is blocked
  // "Unavailable Online" will be added to the notes section.
  updateFundNote(
    fund,
    missingRedemptionFeature(fund, deliveryMethod) === 'all',
    FundNoteQCD.UNAVAILABLE_FOR_REDEMPTION_ONLINE,
    DISABLE_ON_MATCH
  );

  // If client has a fund that has a "Stop Mail" service in agreement level
  // checking addressChangeOnSameDay for edge case scenario (seen in prod)
  // "Address Undeliverable" will be added to the notes section.
  updateFundNote(
    fund,
    checkFoundFeaturesByCode(fund, SystemCode.STOP_MAIL_ID) &&
      !fund.addressChangedSameDay &&
      deliveryMethod !== DELIVERY_MAIL_CHECK_TO_SCHOOL,
    FundNoteQCD.ADDRESS_UNDELIVERABLE,
    DISABLE_ON_MATCH
  );

  // If client has a fund with agreementType 'EDUCATION_SAVINGS_ACCOUNT'
  // "ESA-PLAN" will be added to the notes section.
  updateFundNote(
    fund,
    fund.agreementType === 'EDUCATION_SAVINGS_ACCOUNT',
    FundNoteQCD.ESA_PLAN,
    DISABLE_ON_MATCH
  );

  // If client has a fund with PendingTransactions that does not exceed redeemable funds
  // "transaction pending" will be added to the notes section.
  updateFundNote(
    fund,
    fund.hasPendingTransaction && fund.redeemableFundDollars !== 0,
    FundNoteQCD.PENDING
  );

  // If client has a fund with PendingTransactions and the amount exceeds redeemable funds
  // "transaction pending" will be added to the notes section.
  updateFundNote(
    fund,
    fund.hasPendingTransaction && fund.redeemableFundDollars === 0,
    FundNoteQCD.PENDING_TRANSACTION,
    DISABLE_ON_MATCH
  );

  updateFundNote(
    fund,
    fund.agreementType === NON_FIDUCIARY_PLAN,
    FundNoteQCD.NON_FIDUCIARY_FUND,
    DISABLE_ON_MATCH
  );

  /* disabling for now for inherited testing - will remove after successful test - 11/20/18    */
  // no more inherited IRA block in sell
  /*updateFundNote(
    fund,
    fund.agreementType === AGREEMENT_TYPES.TRADITIONAL_IRA_DECEASED_BENE ||
      fund.agreementType === AGREEMENT_TYPES.ROTH_IRA_DECEASED_BENE,
    FundNoteQCD.INHERITED_FUND,
    DISABLE_ON_MATCH
  );*/

  updateFundNote(
    fund,
    fund.agreementType === AGREEMENT_TYPES.TRADITIONAL_IRA_DECEASED ||
      fund.agreementType === AGREEMENT_TYPES.ROTH_IRA_DECEASED,
    FundNoteQCD.IRA_DECEASED,
    DISABLE_ON_MATCH
  );

  updateFundNote(
    fund,
    fund.agreementType === AGREEMENT_TYPES.SEP_IRA,
    FundNoteQCD.SEP_IRA,
    DISABLE_ON_MATCH
  );

  updateFundNote(
    fund,
    fund.moneyMarketReformMessage &&
      fund.moneyMarketReformMessageType === MONEY_MARKET_EVENT_GATE &&
      fund.moneyMarketReformMessagePeriod ===
        MONEY_MARKET_EVENT_PERIOD_IN_EVENT,
    FundNoteQCD.MONEY_MARKET_EVENT_GATE_ACTIVE,
    DISABLE_ON_MATCH
  );

  updateFundNote(
    fund,
    fund.moneyMarketReformMessage &&
      fund.moneyMarketReformMessageType === MONEY_MARKET_EVENT_FEE &&
      fund.moneyMarketReformMessagePeriod ===
        MONEY_MARKET_EVENT_PERIOD_IN_EVENT,
    FundNoteQCD.MONEY_MARKET_EVENT_FEE_ACTIVE
  );

  updateFundNote(
    fund,
    fund.moneyMarketReformMessage &&
      fund.moneyMarketReformMessageType === MONEY_MARKET_EVENT_GATE &&
      fund.moneyMarketReformMessagePeriod !==
        MONEY_MARKET_EVENT_PERIOD_IN_EVENT,
    FundNoteQCD.MONEY_MARKET_EVENT_GATE_REMOVED
  );

  updateFundNote(
    fund,
    fund.moneyMarketReformMessage &&
      fund.moneyMarketReformMessageType === MONEY_MARKET_EVENT_FEE &&
      fund.moneyMarketReformMessagePeriod !==
        MONEY_MARKET_EVENT_PERIOD_IN_EVENT,
    FundNoteQCD.MONEY_MARKET_EVENT_FEE_REMOVED
  );

  updateFundNote(
    fund,
    isRAS(fund.productType) && fund.hasEarlyWithdrawalPenalty,
    FundNoteQCD.RAS_EARLY_IRA_WITHDRAWAL,
    DISABLE_ON_MATCH
  );
}
